'use client';

import { AppImageData } from '@components/appImage';
import { PageTitleBlock } from '@components/pageTitleBlock';

import { DATA_2_GIS_HREF } from '../../data-company/constants';

import { useGetClientHost } from '@/shared/hooks';
import { TranslatedComponent } from '@/shared/types';
import { isRuDomain } from '@/shared/utils/getDomainInfo';

interface ClientPageTitleBlock extends TranslatedComponent {
  image: AppImageData;
  imageSize: { width: number; height: number };
}

export const ClientPageTitleBlock = ({
  image,
  imageSize,
  translations,
}: ClientPageTitleBlock) => {
  const host = useGetClientHost();

  return (
    <PageTitleBlock
      titleId="header"
      title={translations.header}
      descriptionId="subheader"
      description={translations.subheader}
      imageData={image}
      imageSize={imageSize}
      imageDimensions={imageSize}
      mainButton={
        // Кнопка «Купить онлайн» доступна только для русского домена
        isRuDomain(host)
          ? {
              label: translations.buttonsBuyOnlineText,
              href: DATA_2_GIS_HREF,
              target: '_blank',
              variant: 'secondary',
            }
          : undefined
      }
      secondaryButton={{
        label: translations.buttonGetConsultation,
        variant: 'primary',
      }}
    />
  );
};
